import { render } from "./AddPicture.vue?vue&type=template&id=f73ba2ae"
import script from "./AddPicture.vue?vue&type=script&lang=js"
export * from "./AddPicture.vue?vue&type=script&lang=js"
script.render = render

export default script